import React, { useEffect } from 'react';
import { Form, Input, Button, Modal, Switch, message } from 'antd';
import {
  useUpdateCompanyMutation,
  useCreateCompanyMutation,
} from 'reducers/company/api';
import { useErrorHandler } from 'common_components/ErrorContext';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { getCurrentUser } from 'reducers/user';
import { goBack } from 'connected-react-router';

const FormComponent = (props) => {
  const { formData, isCreate, readonly } = props;
  const [form] = Form.useForm();
  const user = useSelector(getCurrentUser);
  const dispatch = useDispatch();
  const { setErrorData } = useErrorHandler();
  const [
    createCompany,
    {
      isSuccess: isSuccessCreating,
      isUninitialized: isUninitCreating,
      error: errorCreating,
      isLoading: isCreating,
    },
  ] = useCreateCompanyMutation();
  const [
    updateCompany,
    {
      isSuccess: isSuccessUpdating,
      isUninitialized: isUninitUpdating,
      error: errorUpdating,
      isLoading: isUpdating,
    },
  ] = useUpdateCompanyMutation();

  useEffect(() => {
    if (errorCreating) {
      setErrorData(errorCreating);
    }
    if (errorUpdating) {
      setErrorData(errorUpdating);
    }
  }, [errorUpdating, errorCreating, setErrorData]);

  useEffect(() => {
    if (
      (!isUninitUpdating && isSuccessUpdating) ||
      (!isUninitCreating && isSuccessCreating)
    ) {
      message.success('Data was successfully saved');
      if (isSuccessCreating) {
        dispatch(goBack());
      }
    }
  }, [
    isSuccessUpdating,
    isUninitUpdating,
    isSuccessCreating,
    isUninitCreating,
    dispatch,
  ]);

  const onFinish = (values) => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure want to submit?',
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk: handleConfirmAction,
    });
  };

  const handleConfirmAction = () => {
    let validData = form.getFieldsValue(true);

    let postData = { id: formData && formData.id, ...validData };

    if (isCreate) {
      createCompany(postData);
    } else {
      updateCompany(postData);
    }
  };
  return (
    <Form
      form={form}
      name='basic'
      labelCol={{
        span: 4,
      }}
      wrapperCol={{
        span: 10,
      }}
      style={{ padding: '20px' }}
      onFinish={onFinish}
      autoComplete='off'
    >
      <Form.Item
        wrapperCol={{
          offset: 12,
          span: 12,
        }}
      >
        <Button
          type='primary'
          htmlType='submit'
          loading={isCreating || isUpdating}
          disabled={readonly}
        >
          Submit
        </Button>
      </Form.Item>
      <Form.Item
        label='Name'
        name='name'
        initialValue={formData && formData.name}
        rules={[
          {
            required: true,
            message: 'Please input name',
          },
        ]}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        label='Fullname (EN)'
        name='fullname_en'
        initialValue={formData && formData.fullname_en}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        label='Fullname (TH)'
        name='fullname_th'
        initialValue={formData && formData.fullname_th}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        label='Shortname (EN)'
        name='shortname_en'
        initialValue={formData && formData.shortname_en}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        label='Shortname (TH)'
        name='shortname_th'
        initialValue={formData && formData.shortname_th}
      >
        <Input disabled={readonly} />
      </Form.Item>
      {user && user.is_superadmin && (
        <Form.Item
          label='Is Active'
          name='is_active'
          initialValue={formData && formData.is_active}
          valuePropName='checked'
        >
          <Switch />
        </Form.Item>
      )}
    </Form>
  );
};

export default FormComponent;
